// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/prjm.eot?3k806f", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/prjm.woff2?3k806f", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/prjm.ttf?3k806f", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/prjm.woff?3k806f", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/prjm.svg?3k806f", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Philosopher:ital,wght@0,400;0,700;1,400;1,700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#prjm" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS Document */

/***************** fonts ******************/

@font-face {
	font-family: "prjm";
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"),
		 url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
		 url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype"),
		 url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff"),
		 url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg");
	font-weight: normal;
	font-style: normal;
}

/***************** html tag ******************/
/* html, body {
	height: 100%;
} */

* {
	scroll-behavior: smooth;
}

body {
	/* background-color: #000000; */
	/* color: #f5f5f5; */
	cursor: default;
	font-family: "Philosopher", sans-serif;
	/* font-family: "Exo 2", sans-serif; */
	font-size: 16px;
	font-weight: 400;
	line-height: 1.2em;
	padding-bottom: 1em;
	padding-top: 51px;
}

a, 
a:hover {
	color: hsl(198, 80%, 45%);
	text-decoration: none;
}

label {
	font-size: 17px;
	font-weight: normal;
	line-height: 1em;
}

strong {
	font-weight: 700;
}

::-webkit-input-placeholder {
 	color: hsl(198, 50%, 75%);
}

:-ms-input-placeholder {
 	color: hsl(198, 50%, 75%);
}

::placeholder {
	color: hsl(198, 50%, 75%);
}

/******************** overrides *******************/

.modal-backdrop.show + .modal-backdrop.show {
	z-index: 1090;
}


/******************** site *******************/
.addForm button {
	margin: 5px 0;
}

.addForm .form-group {
	margin: 0;
	width: 100%;
}

.addForm .form-inline input, 
.addForm .form-inline textarea, 
.addForm .form-inline select {
	background-color: #f5f5f5;
	margin: 5px 0;
	width: 100%;
}

.boxList .list-group-item {
	background-color: #232323;
	border-color: #185f7d #242424 #242424;
	border-style: solid;
	border-width: 1px;
	cursor: pointer;
	overflow: hidden;
	padding: 10px 15px;
	position: relative;
}

.boxList .list-group-item:hover, 
.boxList .list-group-item:focus {
	background-color: #232323;
	border-color: #185f7d;
}

.boxList .list-group-item h5 {
	color: #1798d1;
	font-size: 16px;
}

.boxList .list-group-item:hover h5 {
	color: #f5f5f5;
}

.hilite {
	border: 2px solid #ee7614;
	box-shadow: 0 0 20px 5px #ee7614;
	transition: all .3s;
	z-index: 1;
}

.linkedToBox {
	background: #ee7614;
	border-radius: 5px 0 5px 5px;
	color: #f5f5f5;
	cursor: alias;
	font-size: 14px;
	line-height: 1em;
	margin: 0 5px 0 8px;
	padding: 5px;
}

.priorityBox {
	height: 100%;
	left: 0;
	position: relative;
	top: 0;
	width: 25px;
	/* z-index: 99; */
}

.priorityBox:hover {
	width: 80px;
}

.priorityBox[class*="priority"]:before {
	border-left: 15px solid #4e4e4e;
	color: #ffffff;
	content: "";
	height: 100%;
	left: 0;
	position: absolute;
	top: 0;
	width: 100%;
}

.priorityBox.priority1:before {
	border-color: #EC4F2A;
}

.priorityBox.priority2:before {
	border-color: #F2CB07;
}

.priorityBox.priority3:before {
	border-color: #1798D1;
}

.priorityBox.priority4:before {
	border-color: #8EDB56;
}

.priorityBox.priority5:before {
	border-color: #A78ED2;
}

.priorityBox[class*="priority"]:hover:after {
	border-radius: 0 10px 0 0;
	bottom: 0;
	content: "Not set";
	font-size: 12px;
	height: 20px;
	left: 0;
	position: absolute;
	text-align: center;
	text-shadow: 1px 1px 2px rgba(0, 0, 0, 1);
	width: 80px;
	/* z-index: -1; */
}

.priorityBox.priority1:hover:after, 
#prioritySelect .priority1 {
	background-color: #EC4F2A;
	content: "Urgente";
}

.priorityBox.priority2:hover:after, 
#prioritySelect .priority2 {
	background-color: #F2CB07;
	content: "Importante";
}

.priorityBox.priority3:hover:after, 
#prioritySelect .priority3 {
	background-color: #1798D1;
	content: "Da fare";
}

.priorityBox.priority4:hover:after, 
#prioritySelect .priority4 {
	background-color: #8EDB56;
	content: "Nice to have";
}

.priorityBox.priority5:hover:after, 
#prioritySelect .priority5 {
	background-color: #A78ED2;
	content: "Cosmetico";
}

.boxTitle {
	background: #1798d1;
	border-radius: 0 0 10px 10px;
	line-height: 1.3em;
	margin: 0 0 15px;
	padding: 5px 0 10px;
	text-align: center;
}

.boxTitle small {
	color: #f5f5f5;
}

.toast.show:hover {
	background-color: rgba(23, 152, 209, 0.1);
	border-color: #1798d1;
}

#logoBtn {
	color: #1798d1;
	font-size: 30px;
	height: auto;
	line-height: 1em;
	padding: 10px 15px;
}

#mainContainer {
	padding-bottom: 5em;
}

#prioritySelect option[class*="priority"] {
	color: #333333;
}

/* #showAllClosedProjectsChk, 
#showAllOpenProjectsChk, 
#showAllProjectsChk,
#showAllClosedActivitiesChk, 
#showAllOpenActivitiesChk, 
#showAllActivitiesChk {
	padding: 3px 6px;
}

#showAllClosedProjectsChk [class^="icon-"], 
#showAllOpenProjectsChk [class^="icon-"], 
#showAllProjectsChk [class^="icon-"],
#showAllClosedActivitiesChk [class^="icon-"], 
#showAllOpenActivitiesChk [class^="icon-"], 
#showAllActivitiesChk [class^="icon-"] {
	font-size: 28px;
	line-height: 1em;
} */

/* #signInBtn {
	border-radius: 0;
	font-size: 23px;
	text-transform: uppercase;
} */

#signInForm input {
	background: transparent;
	border-radius: 0;
	color: #FFFFFF;
}

#signInForm span[class^="icon-"] {
	font-size: 26px;
	vertical-align: text-bottom;
}

#signInForm span.input-group-addon {
	background-color: #1798d1;
	border-radius: 0;
	color: #FFFFFF;
}

#signInMsgDisplay {
	color: #E43D3D;
	height: 45px;
	margin-bottom: 15px;
	overflow: hidden;
	padding: 0 10px;
	text-shadow: 0 0 5px rgba(0, 0, 0, 1), 0 0 5px rgba(0, 0, 0, 1), 0 0 5px rgba(0, 0, 0, 1), 0 0 5px rgba(0, 0, 0, 1);
}

#toolbarBox {
/*
	background-color: #232323;
	border-color: #185f7d;
	border-style: solid;
	border-width: 1px;
	margin: 10px 0 0;
*/
}

#toolbarBox [type=button] {
	border-radius: 0;
}

#toolbarBox > * {
	float: right;
}

#topBar {
	padding: 0;;
}

#topBar .navbar-toggle.collapsed {
	background-color: #333333;
}

#topBar .navbar-toggle.collapsed .icon-bar {
	background-color: #1798d1;
}

#topBar .navbar-toggle {
	background-color: #1798d1;
}

#topBar .navbar-toggle .icon-bar {
	background-color: #333333;
}

/******************** mediaQuery *******************/
@media (max-width: 767px) {
	#mainMenu .navbar-right {
		margin: 0 -15px;;
	}

	#mainMenu li {
		border-color: #185f7d;
		border-style: solid;
		border-width: 0 0 1px;
	}

	#mainMenu li:first-child {
		border-width: 1px 0;
	}
	
	#prjName {
		margin-bottom: 10px;
	}
}

@media (min-width: 768px) and (max-width: 991px) {
	#prjName {
		margin-bottom: 10px;
	}
}

@media (min-width: 992px) and (max-width: 1199px) {
}













.content-filter label span {
	font-size: 2em!important;
}











input:not(:checked) + label + button {
	display: none;
}




.attachment-loading {
	animation: attachment-loading .5s alternate infinite;
}

@keyframes attachment-loading {
	0% { background-color: rgba(242, 203, 7, 0); }
	100% { background-color: rgba(242, 148, 7, 0.7); }
}

.cursor-pointer {
	cursor: pointer;
}

.priority-box {
	color: #ffffff;
	padding: 0.2em;
	min-width: 2em;
}

.priority-box.priority1 {
	background-color: #EC4F2A;
}

.priority-box.priority2 {
	background-color: #F2CB07;
}

.priority-box.priority3 {
	background-color: #1798D1;
}

.priority-box.priority4 {
	background-color: #8EDB56;
}

.priority-box.priority5 {
	background-color: #A78ED2;
}
`, "",{"version":3,"sources":["webpack://./src/css/custom.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB,2CAA2C;;AAG3C;CACC,mBAAmB;CACnB,4CAAoC;CACpC;;;;wDAIoD;CACpD,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA,8CAA8C;AAC9C;;GAEG;;AAEH;CACC,uBAAuB;AACxB;;AAEA;CACC,+BAA+B;CAC/B,oBAAoB;CACpB,eAAe;CACf,sCAAsC;CACtC,sCAAsC;CACtC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;;CAEC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA,mDAAmD;;AAEnD;CACC,aAAa;AACd;;;AAGA,8CAA8C;AAC9C;CACC,aAAa;AACd;;AAEA;CACC,SAAS;CACT,WAAW;AACZ;;AAEA;;;CAGC,yBAAyB;CACzB,aAAa;CACb,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,qCAAqC;CACrC,mBAAmB;CACnB,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;;CAEC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,gCAAgC;CAChC,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,mBAAmB;CACnB,4BAA4B;CAC5B,cAAc;CACd,aAAa;CACb,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,OAAO;CACP,kBAAkB;CAClB,MAAM;CACN,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,+BAA+B;CAC/B,cAAc;CACd,WAAW;CACX,YAAY;CACZ,OAAO;CACP,kBAAkB;CAClB,MAAM;CACN,WAAW;AACZ;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;CACzB,SAAS;CACT,kBAAkB;CAClB,eAAe;CACf,YAAY;CACZ,OAAO;CACP,kBAAkB;CAClB,kBAAkB;CAClB,yCAAyC;CACzC,WAAW;CACX,iBAAiB;AAClB;;AAEA;;CAEC,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;;CAEC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;;CAEC,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;;CAEC,yBAAyB;CACzB,uBAAuB;AACxB;;AAEA;;CAEC,yBAAyB;CACzB,oBAAoB;AACrB;;AAEA;CACC,mBAAmB;CACnB,4BAA4B;CAC5B,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,yCAAyC;CACzC,qBAAqB;AACtB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,YAAY;CACZ,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;;;;;;;;;;;;;;;;;GAiBG;;AAEH;;;;GAIG;;AAEH;CACC,uBAAuB;CACvB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,2BAA2B;AAC5B;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,mBAAmB;CACnB,gBAAgB;CAChB,eAAe;CACf,mHAAmH;AACpH;;AAEA;AACA;;;;;;CAMC;AACD;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA,oDAAoD;AACpD;CACC;EACC,eAAe;CAChB;;CAEA;EACC,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;CACtB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;AACD;;AAEA;CACC;EACC,mBAAmB;CACpB;AACD;;AAEA;AACA;;;;;;;;;;;;;;AAcA;CACC,wBAAwB;AACzB;;;;;;;;;;;;AAYA;CACC,aAAa;AACd;;;;;AAKA;CACC,oDAAoD;AACrD;;AAEA;CACC,KAAK,sCAAsC,EAAE;CAC7C,OAAO,wCAAwC,EAAE;AAClD;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,cAAc;CACd,cAAc;AACf;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B","sourcesContent":["/* CSS Document */\r\n\r\n/***************** fonts ******************/\r\n@import url('https://fonts.googleapis.com/css2?family=Philosopher:ital,wght@0,400;0,700;1,400;1,700&display=swap');\r\n\r\n@font-face {\r\n\tfont-family: \"prjm\";\r\n\tsrc: url(\"../fonts/prjm.eot?3k806f\");\r\n\tsrc: url(\"../fonts/prjm.eot?3k806f#iefix\") format(\"embedded-opentype\"),\r\n\t\t url(\"../fonts/prjm.woff2?3k806f\") format(\"woff2\"),\r\n\t\t url(\"../fonts/prjm.ttf?3k806f\") format(\"truetype\"),\r\n\t\t url(\"../fonts/prjm.woff?3k806f\") format(\"woff\"),\r\n\t\t url(\"../fonts/prjm.svg?3k806f#prjm\") format(\"svg\");\r\n\tfont-weight: normal;\r\n\tfont-style: normal;\r\n}\r\n\r\n/***************** html tag ******************/\r\n/* html, body {\r\n\theight: 100%;\r\n} */\r\n\r\n* {\r\n\tscroll-behavior: smooth;\r\n}\r\n\r\nbody {\r\n\t/* background-color: #000000; */\r\n\t/* color: #f5f5f5; */\r\n\tcursor: default;\r\n\tfont-family: \"Philosopher\", sans-serif;\r\n\t/* font-family: \"Exo 2\", sans-serif; */\r\n\tfont-size: 16px;\r\n\tfont-weight: 400;\r\n\tline-height: 1.2em;\r\n\tpadding-bottom: 1em;\r\n\tpadding-top: 51px;\r\n}\r\n\r\na, \r\na:hover {\r\n\tcolor: hsl(198, 80%, 45%);\r\n\ttext-decoration: none;\r\n}\r\n\r\nlabel {\r\n\tfont-size: 17px;\r\n\tfont-weight: normal;\r\n\tline-height: 1em;\r\n}\r\n\r\nstrong {\r\n\tfont-weight: 700;\r\n}\r\n\r\n::-webkit-input-placeholder {\r\n \tcolor: hsl(198, 50%, 75%);\r\n}\r\n\r\n:-ms-input-placeholder {\r\n \tcolor: hsl(198, 50%, 75%);\r\n}\r\n\r\n::placeholder {\r\n\tcolor: hsl(198, 50%, 75%);\r\n}\r\n\r\n/******************** overrides *******************/\r\n\r\n.modal-backdrop.show + .modal-backdrop.show {\r\n\tz-index: 1090;\r\n}\r\n\r\n\r\n/******************** site *******************/\r\n.addForm button {\r\n\tmargin: 5px 0;\r\n}\r\n\r\n.addForm .form-group {\r\n\tmargin: 0;\r\n\twidth: 100%;\r\n}\r\n\r\n.addForm .form-inline input, \r\n.addForm .form-inline textarea, \r\n.addForm .form-inline select {\r\n\tbackground-color: #f5f5f5;\r\n\tmargin: 5px 0;\r\n\twidth: 100%;\r\n}\r\n\r\n.boxList .list-group-item {\r\n\tbackground-color: #232323;\r\n\tborder-color: #185f7d #242424 #242424;\r\n\tborder-style: solid;\r\n\tborder-width: 1px;\r\n\tcursor: pointer;\r\n\toverflow: hidden;\r\n\tpadding: 10px 15px;\r\n\tposition: relative;\r\n}\r\n\r\n.boxList .list-group-item:hover, \r\n.boxList .list-group-item:focus {\r\n\tbackground-color: #232323;\r\n\tborder-color: #185f7d;\r\n}\r\n\r\n.boxList .list-group-item h5 {\r\n\tcolor: #1798d1;\r\n\tfont-size: 16px;\r\n}\r\n\r\n.boxList .list-group-item:hover h5 {\r\n\tcolor: #f5f5f5;\r\n}\r\n\r\n.hilite {\r\n\tborder: 2px solid #ee7614;\r\n\tbox-shadow: 0 0 20px 5px #ee7614;\r\n\ttransition: all .3s;\r\n\tz-index: 1;\r\n}\r\n\r\n.linkedToBox {\r\n\tbackground: #ee7614;\r\n\tborder-radius: 5px 0 5px 5px;\r\n\tcolor: #f5f5f5;\r\n\tcursor: alias;\r\n\tfont-size: 14px;\r\n\tline-height: 1em;\r\n\tmargin: 0 5px 0 8px;\r\n\tpadding: 5px;\r\n}\r\n\r\n.priorityBox {\r\n\theight: 100%;\r\n\tleft: 0;\r\n\tposition: relative;\r\n\ttop: 0;\r\n\twidth: 25px;\r\n\t/* z-index: 99; */\r\n}\r\n\r\n.priorityBox:hover {\r\n\twidth: 80px;\r\n}\r\n\r\n.priorityBox[class*=\"priority\"]:before {\r\n\tborder-left: 15px solid #4e4e4e;\r\n\tcolor: #ffffff;\r\n\tcontent: \"\";\r\n\theight: 100%;\r\n\tleft: 0;\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\twidth: 100%;\r\n}\r\n\r\n.priorityBox.priority1:before {\r\n\tborder-color: #EC4F2A;\r\n}\r\n\r\n.priorityBox.priority2:before {\r\n\tborder-color: #F2CB07;\r\n}\r\n\r\n.priorityBox.priority3:before {\r\n\tborder-color: #1798D1;\r\n}\r\n\r\n.priorityBox.priority4:before {\r\n\tborder-color: #8EDB56;\r\n}\r\n\r\n.priorityBox.priority5:before {\r\n\tborder-color: #A78ED2;\r\n}\r\n\r\n.priorityBox[class*=\"priority\"]:hover:after {\r\n\tborder-radius: 0 10px 0 0;\r\n\tbottom: 0;\r\n\tcontent: \"Not set\";\r\n\tfont-size: 12px;\r\n\theight: 20px;\r\n\tleft: 0;\r\n\tposition: absolute;\r\n\ttext-align: center;\r\n\ttext-shadow: 1px 1px 2px rgba(0, 0, 0, 1);\r\n\twidth: 80px;\r\n\t/* z-index: -1; */\r\n}\r\n\r\n.priorityBox.priority1:hover:after, \r\n#prioritySelect .priority1 {\r\n\tbackground-color: #EC4F2A;\r\n\tcontent: \"Urgente\";\r\n}\r\n\r\n.priorityBox.priority2:hover:after, \r\n#prioritySelect .priority2 {\r\n\tbackground-color: #F2CB07;\r\n\tcontent: \"Importante\";\r\n}\r\n\r\n.priorityBox.priority3:hover:after, \r\n#prioritySelect .priority3 {\r\n\tbackground-color: #1798D1;\r\n\tcontent: \"Da fare\";\r\n}\r\n\r\n.priorityBox.priority4:hover:after, \r\n#prioritySelect .priority4 {\r\n\tbackground-color: #8EDB56;\r\n\tcontent: \"Nice to have\";\r\n}\r\n\r\n.priorityBox.priority5:hover:after, \r\n#prioritySelect .priority5 {\r\n\tbackground-color: #A78ED2;\r\n\tcontent: \"Cosmetico\";\r\n}\r\n\r\n.boxTitle {\r\n\tbackground: #1798d1;\r\n\tborder-radius: 0 0 10px 10px;\r\n\tline-height: 1.3em;\r\n\tmargin: 0 0 15px;\r\n\tpadding: 5px 0 10px;\r\n\ttext-align: center;\r\n}\r\n\r\n.boxTitle small {\r\n\tcolor: #f5f5f5;\r\n}\r\n\r\n.toast.show:hover {\r\n\tbackground-color: rgba(23, 152, 209, 0.1);\r\n\tborder-color: #1798d1;\r\n}\r\n\r\n#logoBtn {\r\n\tcolor: #1798d1;\r\n\tfont-size: 30px;\r\n\theight: auto;\r\n\tline-height: 1em;\r\n\tpadding: 10px 15px;\r\n}\r\n\r\n#mainContainer {\r\n\tpadding-bottom: 5em;\r\n}\r\n\r\n#prioritySelect option[class*=\"priority\"] {\r\n\tcolor: #333333;\r\n}\r\n\r\n/* #showAllClosedProjectsChk, \r\n#showAllOpenProjectsChk, \r\n#showAllProjectsChk,\r\n#showAllClosedActivitiesChk, \r\n#showAllOpenActivitiesChk, \r\n#showAllActivitiesChk {\r\n\tpadding: 3px 6px;\r\n}\r\n\r\n#showAllClosedProjectsChk [class^=\"icon-\"], \r\n#showAllOpenProjectsChk [class^=\"icon-\"], \r\n#showAllProjectsChk [class^=\"icon-\"],\r\n#showAllClosedActivitiesChk [class^=\"icon-\"], \r\n#showAllOpenActivitiesChk [class^=\"icon-\"], \r\n#showAllActivitiesChk [class^=\"icon-\"] {\r\n\tfont-size: 28px;\r\n\tline-height: 1em;\r\n} */\r\n\r\n/* #signInBtn {\r\n\tborder-radius: 0;\r\n\tfont-size: 23px;\r\n\ttext-transform: uppercase;\r\n} */\r\n\r\n#signInForm input {\r\n\tbackground: transparent;\r\n\tborder-radius: 0;\r\n\tcolor: #FFFFFF;\r\n}\r\n\r\n#signInForm span[class^=\"icon-\"] {\r\n\tfont-size: 26px;\r\n\tvertical-align: text-bottom;\r\n}\r\n\r\n#signInForm span.input-group-addon {\r\n\tbackground-color: #1798d1;\r\n\tborder-radius: 0;\r\n\tcolor: #FFFFFF;\r\n}\r\n\r\n#signInMsgDisplay {\r\n\tcolor: #E43D3D;\r\n\theight: 45px;\r\n\tmargin-bottom: 15px;\r\n\toverflow: hidden;\r\n\tpadding: 0 10px;\r\n\ttext-shadow: 0 0 5px rgba(0, 0, 0, 1), 0 0 5px rgba(0, 0, 0, 1), 0 0 5px rgba(0, 0, 0, 1), 0 0 5px rgba(0, 0, 0, 1);\r\n}\r\n\r\n#toolbarBox {\r\n/*\r\n\tbackground-color: #232323;\r\n\tborder-color: #185f7d;\r\n\tborder-style: solid;\r\n\tborder-width: 1px;\r\n\tmargin: 10px 0 0;\r\n*/\r\n}\r\n\r\n#toolbarBox [type=button] {\r\n\tborder-radius: 0;\r\n}\r\n\r\n#toolbarBox > * {\r\n\tfloat: right;\r\n}\r\n\r\n#topBar {\r\n\tpadding: 0;;\r\n}\r\n\r\n#topBar .navbar-toggle.collapsed {\r\n\tbackground-color: #333333;\r\n}\r\n\r\n#topBar .navbar-toggle.collapsed .icon-bar {\r\n\tbackground-color: #1798d1;\r\n}\r\n\r\n#topBar .navbar-toggle {\r\n\tbackground-color: #1798d1;\r\n}\r\n\r\n#topBar .navbar-toggle .icon-bar {\r\n\tbackground-color: #333333;\r\n}\r\n\r\n/******************** mediaQuery *******************/\r\n@media (max-width: 767px) {\r\n\t#mainMenu .navbar-right {\r\n\t\tmargin: 0 -15px;;\r\n\t}\r\n\r\n\t#mainMenu li {\r\n\t\tborder-color: #185f7d;\r\n\t\tborder-style: solid;\r\n\t\tborder-width: 0 0 1px;\r\n\t}\r\n\r\n\t#mainMenu li:first-child {\r\n\t\tborder-width: 1px 0;\r\n\t}\r\n\t\r\n\t#prjName {\r\n\t\tmargin-bottom: 10px;\r\n\t}\r\n}\r\n\r\n@media (min-width: 768px) and (max-width: 991px) {\r\n\t#prjName {\r\n\t\tmargin-bottom: 10px;\r\n\t}\r\n}\r\n\r\n@media (min-width: 992px) and (max-width: 1199px) {\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.content-filter label span {\r\n\tfont-size: 2em!important;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\ninput:not(:checked) + label + button {\r\n\tdisplay: none;\r\n}\r\n\r\n\r\n\r\n\r\n.attachment-loading {\r\n\tanimation: attachment-loading .5s alternate infinite;\r\n}\r\n\r\n@keyframes attachment-loading {\r\n\t0% { background-color: rgba(242, 203, 7, 0); }\r\n\t100% { background-color: rgba(242, 148, 7, 0.7); }\r\n}\r\n\r\n.cursor-pointer {\r\n\tcursor: pointer;\r\n}\r\n\r\n.priority-box {\r\n\tcolor: #ffffff;\r\n\tpadding: 0.2em;\r\n\tmin-width: 2em;\r\n}\r\n\r\n.priority-box.priority1 {\r\n\tbackground-color: #EC4F2A;\r\n}\r\n\r\n.priority-box.priority2 {\r\n\tbackground-color: #F2CB07;\r\n}\r\n\r\n.priority-box.priority3 {\r\n\tbackground-color: #1798D1;\r\n}\r\n\r\n.priority-box.priority4 {\r\n\tbackground-color: #8EDB56;\r\n}\r\n\r\n.priority-box.priority5 {\r\n\tbackground-color: #A78ED2;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
